import * as React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import IconMask from "../IconMask";
import SearchSelect from "../forms/SearchSelect";
import {
  Box,
  Dialog,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import Forms from "../forms/Forms";
import { app } from "../../services";
import moment from "moment";
import { DeleteForeverOutlined } from "@mui/icons-material";
import { isObject } from "superagent/lib/utils";
import { hasAtLeastOneApplication } from "../../utils/deviceApplications";
import { saveEditableRecord } from "./editableModelUtils";

export default function EditableModel({
  model,
  mode,
  item,
  firstButtons,
  endButtons,
  closeButton,
  withOutTitle,
  ownerName = null,
  readOnly = false,
  onSave = () => { },
  onClose = () => { },
}) {
  const institution = useSelector((state) => state.session.institution);
  const token = useSelector((state) => state.session.token);
  const user = useSelector((state) => state.session.globalUser);
  const [errorItems, setErrorItems] = React.useState(null);
  const [itemRemove, setItemRemove] = React.useState(null);
  const [childrens, setChildrens] = React.useState({});
  const catalogs = useSelector((state) => state.catalogs.persistent);
  const services = !!model?.service ? app.service(model?.service) : null;
  const [editItem, setEditItem] = React.useState(item);
  const [saving, setSaving] = React.useState(false);
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  React.useEffect(() => {
    setEditItem({ ...editItem, id_institucion: institution?.id });
  }, [institution]);
  React.useEffect(() => {
    return () => {
      setEditItem(null);
    };
  }, []);
  const getDataDefault = (modelAction) => {
    const defaultValues = {};
    // console.log('modelAction', modelAction);

    (modelAction?.columns || [])
      .filter((e) => !!e.value)
      .map((item) => {
        // console.log('columns', item, [item.value.type]);
        let value = null;
        switch (item.value.type) {
          case "model": {
            value = model[item.value.keyPath];
            break;
          }
          case "user": {
            // console.log('user', user);

            value = user[item?.value?.keyPath];
            break;
          }
          default:
            value = null;
        }
        defaultValues[item.id] = value;
      });
    // console.log('default', defaultValues);
    return defaultValues;
  };

  const onSaveHandler = async (item, model, editItem) => {
    console.log("item save", item, editItem);
    if (saving) return;
    setSaving(true);
    try {
      const editing = Boolean(item?.id || editItem?.id);
      const res = await saveEditableRecord({
        service: services,
        item,
        editItem,
        defaultValues: model.defaultValues || {},
      });
      if (editing) {
        if (onSave) await onSave(res);
        !closeButton && onClose();
      } else {
        if (onSave) await onSave(res);
        setEditItem({ ...editItem, id: res.id });
        !closeButton && onClose();
      }
    } catch (error) {
      console.log("error", error);
      setErrorItems({
        title: "¡Ups!",
        fields: error?.errors?.length
          ? error?.errors?.map((e) => {
            return { label: e.message };
          })
          : [{ label: error?.message || "Intenta de nuevo" }],
      });
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    let query = {};
    Object.keys(itemRemove).map((key) => {
      if (!isObject(itemRemove[key])) {
        query[key] = itemRemove[key];
      }
    });
    try {
      let response = null;
      var baseURL = process.env.REACT_APP_API_URL || "http://localhost:3030";
      const url = `${baseURL}/${model.service}/${itemRemove.id}`;
      const res = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      // Verificar si la respuesta es exitosa (código de estado 2xx)
      if (res?.ok) {
        // Obtener la data
        response = await res?.json();
        // Manejar la data
        console.log("response", response);
      } else {
        // Manejar errores de la solicitud
        console.error(
          "Error al realizar la solicitud:",
          res?.status,
          res?.statusText
        );
      }
      console.log("response?.data", response);
      setItemRemove(null);
      setEditItem(null);
    } catch (error) {
      console.log("error", error);
    }
  };
  const allowRemove = (item, model) => {
    if (!item || !model || !model.columns) return false;
    let columnsChildrens = model.columns.filter(
      (e) => e.relation?.id_type === "toMany"
    );
    const childrensReports = Object.values(childrens);
    if (
      columnsChildrens.length === childrensReports.length &&
      childrensReports.filter((e) => e.length === 0).length ===
      columnsChildrens.length
    ) {
      return true;
    }
    return false;
  };
  const setButtonRemove = (children) => {
    setChildrens((prevState) => ({
      ...prevState, // Copiar todos los atributos previos
      ...children,
    }));
  };
  const agregar = !!item?.id || !!editItem?.id;
  // console.log('------->', user)
  const isSystem = user?.roles?.find(
    (e) => e?.rol?.id === "663536e2-bdb4-4887-a313-c42d3e00bc37"
  );
  // console.log('edit item', agregar, item?.id || editItem?.id, institution?.roles);
  const allowEdit =
    !!(
      model?.actionsRoles?.create.find((e) =>
        institution?.roles?.find((r) => r.id_rol === e)
      ) || []
    ).length || (model?.actionsRoles?.create || []).includes("all");
  const formModel = readOnly
    ? {
      ...model,
      columns: (model?.columns || []).map((field) => ({ ...field, readOnly: true })),
      modelAction: model?.modelAction
        ? {
          ...model.modelAction,
          columns: (model.modelAction.columns || []).map((field) => ({ ...field, readOnly: true })),
        }
        : model?.modelAction,
    }
    : model;
  console.log("allowed", allowEdit, model?.methods);
  const defaultValue = getDataDefault(model?.modelAction || model) || {};
  return [
    !withOutTitle && (
      <DialogTitle style={{ whiteSpace: 'pre-line' }}>
        {
          ownerName && `${ownerName}\n`
        }
        {!!editItem?.id
          ? "Editar " + model?.title || ""
          : "Agregar " + model?.title || ""}
      </DialogTitle>
    ),
    <DialogContent style={{ minWidth: 300, padding: 8 }}>
      <Stack spacing={2}>
        <Forms
          setButtonRemove={setButtonRemove}
          model={formModel?.modelAction || formModel}
          item={{ ...item, ...editItem, ...defaultValue }}
          path={""}
        />
      </Stack>
    </DialogContent>,
    <DialogActions
      style={{
        justifyContent: "flex-end",
        overflow: "hidden",
        padding: "8px 16px",
      }}
    >
      {firstButtons || null}
      {closeButton || (
        <Button
          fullWidth
          key={"cancel"}
          variant="outlined"
          onClick={() => {
            setEditItem(null);
            onClose();
          }}
        >
          {readOnly ? "Cerrar" : "Cancelar"}
        </Button>
      )}
      {!readOnly && <Button
        fullWidth
        key={"save"}
        disabled={saving ||
          !institution?.roles?.find(
            (e) =>
              e.rol?.id === "cab3b86a-09db-4808-85ff-bc235fd7b6f9" ||
              e.rol?.id === "663536e2-bdb4-4887-a313-c42d3e00bc37" ||
              e.rol?.id === "663536e2-bdb4-4887-a313-c42d3e00bc37"
          ) &&
          !isSystem &&
          !allowEdit
        }
        variant="outlined"
        onClick={() => {
          // console.log('entro ----->', model)
          const obj = {};
          const requiredFilter = [];
          (model?.modelAction?.columns || model?.columns || []).map(
            (field, index) => {
              [...(field.fields || [field])].map((innerField) => {
                const id = (model.id || "") + innerField.id;
                const element = document.getElementById(id);
                const value = innerField.component === "boolean"
                  ? Boolean(element?.checked)
                  : element?.value;
                // console.log('doc', doc, value, field.id);
                const isBlankRequiredText =
                  innerField.required &&
                  typeof value === "string" &&
                  value.trim().length === 0;
                if (
                  value !== undefined &&
                  value !== "" &&
                  value !== null &&
                  !isBlankRequiredText
                ) {
                  if (innerField.component === "boolean") {
                    obj[innerField.id] = value;
                  } else if (`${innerField.id}`.startsWith("dt_")) {
                    console.log("value date", value);
                    obj[innerField.id] = moment(
                      value,
                      `${value}`.includes("/") ? "DD/MM/YYYY" : undefined
                    ).format(
                      `${value}`.includes(":")
                        ? "YYYY-MM-DD HH:mm:ss"
                        : "YYYY-MM-DD"
                    );
                  } else {
                    obj[innerField.id] = value;
                  }
                } else if (innerField.id !== "id") {
                  innerField?.required && requiredFilter.push(innerField);
                  obj[innerField.id] = null;
                } else {
                  innerField?.required && requiredFilter.push(innerField);
                }
              });
            }
          );
          const defaultObj = {};
          model?.defaultSystem?.map((item, index) => {
            switch (true) {
              case item.param === "institution": {
                defaultObj[item.vc_field] =
                  (institution || {})[item.key] || undefined;
                break;
              }
              case item.param === "user": {
                defaultObj[item.vc_field] = (user || {})[item.key] || undefined;
                break;
              }
              case item.type === "static": {
                defaultObj[item.vc_field] = item?.value || undefined;
                break;
              }
              default: {
              }
            }
          });
          const val = { ...obj, ...defaultObj };
          // const requiredFilter = model.columns.filter(e => e.required && (val[e.id] === null || val[e.id] === undefined || ((e.fields || ).filter(ei => ei.required && (val[ei.id] === null || val[ei.id] === undefined)))
          console.log('requiredFilter', requiredFilter)
          if (model?.id === "devices-sections" && !hasAtLeastOneApplication(val)) {
            setErrorItems({
              title: "¡Ups!",
              message: "Selecciona al menos una aplicación:",
              fields: [{ label: "TGOne o CEMEDI" }],
            });
          } else if (requiredFilter.length > 0) {
            setErrorItems({
              title: "¡Ups!",
              message: "Los siguientes campos son obligatorios:",
              fields: requiredFilter,
            });
          } else {
            onSaveHandler(val, model, editItem);
          }
        }}
      >
        {mode === "auto" || !!item?.id || !!editItem?.id
          ? "Guardar"
          : "Agregar"}
      </Button>}
      {endButtons || null}
      {!readOnly && allowRemove(editItem, model) && (
        <Button
          onClick={() => setItemRemove(editItem)}
          variant="contained"
          color="error"
        >
          <DeleteForeverOutlined />
        </Button>
      )}
    </DialogActions>,
    <Dialog
      key={"validation"}
      open={!!itemRemove}
      onClose={() => setItemRemove(null)}
    >
      <DialogTitle>{"Eliminar"}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`¿Seguro que desea eliminar esta acción no se puede deshacer?`}
        </DialogContentText>
        <DialogActions>
          <Button onClick={() => setItemRemove(null)}>{"Cancelar"}</Button>
          <Button onClick={handleDelete}>{"Eliminar"}</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>,
    <Dialog key={"errorDialog"} open={!!errorItems}>
      <DialogTitle>{errorItems?.title}</DialogTitle>
      <DialogContent>
        <Typography key={"error"}>{errorItems?.message}</Typography>
        {errorItems?.fields?.map((item, index) => {
          return <Typography key={index}>{item.label}</Typography>;
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setErrorItems(null)}>{"Aceptar"}</Button>
      </DialogActions>
    </Dialog>,
  ];
}
